import { render, staticRenderFns } from "./hot-product.vue?vue&type=template&id=dcb2ee78&scoped=true"
import script from "./hot-product.vue?vue&type=script&lang=js"
export * from "./hot-product.vue?vue&type=script&lang=js"
import style0 from "./hot-product.vue?vue&type=style&index=0&id=dcb2ee78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb2ee78",
  null
  
)

export default component.exports